import * as __typia_transform__validateReport from "typia/lib/internal/_validateReport";
import * as __typia_transform__createStandardSchema from "typia/lib/internal/_createStandardSchema";
import typia from 'typia';
import { logWarn } from '@ardoq/logging';
import { CHART_FENCES, type ChartInput } from './components/charts/chartFences';
import { ACTION_FENCE, type ActionFencePayload, } from './components/actions/types';
import { VIEW_PREVIEW_FENCE, type ViewPreviewPayload, } from './components/viewPreview/viewPreviewFence';
type RenderBase = {
    render_id: string;
    version: 1;
};
export type ChartRender = RenderBase & {
    type: 'chart';
    payload: ChartInput;
};
export type ActionRender = RenderBase & {
    type: 'action';
    payload: ActionFencePayload;
};
export type ViewPreviewRender = RenderBase & {
    type: 'view_preview';
    payload: ViewPreviewPayload;
};
export type RenderMetadata = ChartRender | ActionRender | ViewPreviewRender;
export type RenderStore = Record<string, RenderMetadata>;
export const validateRenderMetadata = (() => { const _io0 = (input: any): boolean => "string" === typeof input.render_id && 1 === input.version && "chart" === input.type && ("object" === typeof input.payload && null !== input.payload && _iu0(input.payload)); const _io1 = (input: any): boolean => (undefined === input.title || "string" === typeof input.title) && (Array.isArray(input.data) && (1 <= input.data.length && input.data.every((elem: any) => "object" === typeof elem && null !== elem && _io2(elem)))) && "bar" === input.chart_type; const _io2 = (input: any): boolean => "string" === typeof input.label && "number" === typeof input.value; const _io3 = (input: any): boolean => (undefined === input.title || "string" === typeof input.title) && (Array.isArray(input.data) && (1 <= input.data.length && input.data.every((elem: any) => "object" === typeof elem && null !== elem && _io2(elem)))) && "pie" === input.chart_type; const _io4 = (input: any): boolean => (undefined === input.title || "string" === typeof input.title) && (Array.isArray(input.data) && (1 <= input.data.length && input.data.every((elem: any) => "object" === typeof elem && null !== elem && _io5(elem)))) && (undefined === input.has_dynamic_y_axis || "boolean" === typeof input.has_dynamic_y_axis) && "line" === input.chart_type; const _io5 = (input: any): boolean => "string" === typeof input.name && (undefined === input.label || "string" === typeof input.label) && (Array.isArray(input.values) && (1 <= input.values.length && input.values.every((elem: any) => "object" === typeof elem && null !== elem && _io6(elem)))); const _io6 = (input: any): boolean => "string" === typeof input.time && "number" === typeof input.value; const _io7 = (input: any): boolean => (undefined === input.title || "string" === typeof input.title) && (Array.isArray(input.data) && (1 <= input.data.length && input.data.every((elem: any) => "object" === typeof elem && null !== elem && _io5(elem)))) && (undefined === input.number_slices || "number" === typeof input.number_slices) && "stacked-bar" === input.chart_type; const _io8 = (input: any): boolean => "string" === typeof input.render_id && 1 === input.version && "action" === input.type && ("object" === typeof input.payload && null !== input.payload && _io9(input.payload)); const _io9 = (input: any): boolean => "string" === typeof input.action && true; const _io10 = (input: any): boolean => "string" === typeof input.render_id && 1 === input.version && "view_preview" === input.type && ("object" === typeof input.payload && null !== input.payload && _io11(input.payload)); const _io11 = (input: any): boolean => "object" === typeof input.traversal && null !== input.traversal && _io12(input.traversal) && ("object" === typeof input.view && null !== input.view && _io14(input.view)); const _io12 = (input: any): boolean => Array.isArray(input.startSet) && input.startSet.every((elem: any) => "string" === typeof elem) && (Array.isArray(input.paths) && input.paths.every((elem: any) => Array.isArray(elem) && elem.every((elem: any) => "object" === typeof elem && null !== elem && _io13(elem)))) && (undefined === input.startSetExpansion || "descendants" === input.startSetExpansion); const _io13 = (input: any): boolean => "string" === typeof input.sourceType && "string" === typeof input.targetType && "string" === typeof input.referenceType && ("outgoing" === input.direction || "incoming" === input.direction); const _io14 = (input: any): boolean => ("bubble" === input.viewName || "timeline" === input.viewName || "dependencyMap" === input.viewName || "relationships3" === input.viewName || "modernizedBlockDiagram" === input.viewName) && (null !== input.milestoneFields && (undefined === input.milestoneFields || "all" === input.milestoneFields || Array.isArray(input.milestoneFields) && input.milestoneFields.every((elem: any) => "string" === typeof elem))) && (undefined === input.bubbleFields || "object" === typeof input.bubbleFields && null !== input.bubbleFields && false === Array.isArray(input.bubbleFields) && _io15(input.bubbleFields)); const _io15 = (input: any): boolean => (undefined === input.x || "string" === typeof input.x) && (undefined === input.y || "string" === typeof input.y) && (undefined === input.size || "string" === typeof input.size); const _iu0 = (input: any): any => (() => {
    if ("pie" === input.chart_type)
        return _io3(input);
    else if ("bar" === input.chart_type)
        return _io1(input);
    else if ("line" === input.chart_type)
        return _io4(input);
    else if ("stacked-bar" === input.chart_type)
        return _io7(input);
    else
        return false;
})(); const _iu1 = (input: any): any => (() => {
    if ("view_preview" === input.type)
        return _io10(input);
    else if ("action" === input.type)
        return _io8(input);
    else if ("chart" === input.type)
        return _io0(input);
    else
        return false;
})(); const _vo0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.render_id || _report(_exceptionable, {
        path: _path + ".render_id",
        expected: "string",
        value: input.render_id
    }), 1 === input.version || _report(_exceptionable, {
        path: _path + ".version",
        expected: "1",
        value: input.version
    }), "chart" === input.type || _report(_exceptionable, {
        path: _path + ".type",
        expected: "\"chart\"",
        value: input.type
    }), ("object" === typeof input.payload && null !== input.payload || _report(_exceptionable, {
        path: _path + ".payload",
        expected: "(BarChartInput | LineChartInput | PieChartInput | StackedBarChartInput)",
        value: input.payload
    })) && _vu0(input.payload, _path + ".payload", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".payload",
        expected: "(BarChartInput | LineChartInput | PieChartInput | StackedBarChartInput)",
        value: input.payload
    })].every((flag: boolean) => flag); const _vo1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [undefined === input.title || "string" === typeof input.title || _report(_exceptionable, {
        path: _path + ".title",
        expected: "(string | undefined)",
        value: input.title
    }), (Array.isArray(input.data) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ChartDataPoint> & MinItems<1>)",
        value: input.data
    })) && ((1 <= input.data.length || _report(_exceptionable, {
        path: _path + ".data",
        expected: "Array<> & MinItems<1>",
        value: input.data
    })) && input.data.map((elem: any, _index10: number) => ("object" === typeof elem && null !== elem || _report(_exceptionable, {
        path: _path + ".data[" + _index10 + "]",
        expected: "ChartDataPoint",
        value: elem
    })) && _vo2(elem, _path + ".data[" + _index10 + "]", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".data[" + _index10 + "]",
        expected: "ChartDataPoint",
        value: elem
    })).every((flag: boolean) => flag)) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ChartDataPoint> & MinItems<1>)",
        value: input.data
    }), "bar" === input.chart_type || _report(_exceptionable, {
        path: _path + ".chart_type",
        expected: "\"bar\"",
        value: input.chart_type
    })].every((flag: boolean) => flag); const _vo2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.label || _report(_exceptionable, {
        path: _path + ".label",
        expected: "string",
        value: input.label
    }), "number" === typeof input.value || _report(_exceptionable, {
        path: _path + ".value",
        expected: "number",
        value: input.value
    })].every((flag: boolean) => flag); const _vo3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [undefined === input.title || "string" === typeof input.title || _report(_exceptionable, {
        path: _path + ".title",
        expected: "(string | undefined)",
        value: input.title
    }), (Array.isArray(input.data) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ChartDataPoint> & MinItems<1>)",
        value: input.data
    })) && ((1 <= input.data.length || _report(_exceptionable, {
        path: _path + ".data",
        expected: "Array<> & MinItems<1>",
        value: input.data
    })) && input.data.map((elem: any, _index11: number) => ("object" === typeof elem && null !== elem || _report(_exceptionable, {
        path: _path + ".data[" + _index11 + "]",
        expected: "ChartDataPoint",
        value: elem
    })) && _vo2(elem, _path + ".data[" + _index11 + "]", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".data[" + _index11 + "]",
        expected: "ChartDataPoint",
        value: elem
    })).every((flag: boolean) => flag)) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ChartDataPoint> & MinItems<1>)",
        value: input.data
    }), "pie" === input.chart_type || _report(_exceptionable, {
        path: _path + ".chart_type",
        expected: "\"pie\"",
        value: input.chart_type
    })].every((flag: boolean) => flag); const _vo4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [undefined === input.title || "string" === typeof input.title || _report(_exceptionable, {
        path: _path + ".title",
        expected: "(string | undefined)",
        value: input.title
    }), (Array.isArray(input.data) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ValidatedChartTimeSeries> & MinItems<1>)",
        value: input.data
    })) && ((1 <= input.data.length || _report(_exceptionable, {
        path: _path + ".data",
        expected: "Array<> & MinItems<1>",
        value: input.data
    })) && input.data.map((elem: any, _index12: number) => ("object" === typeof elem && null !== elem || _report(_exceptionable, {
        path: _path + ".data[" + _index12 + "]",
        expected: "ValidatedChartTimeSeries",
        value: elem
    })) && _vo5(elem, _path + ".data[" + _index12 + "]", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".data[" + _index12 + "]",
        expected: "ValidatedChartTimeSeries",
        value: elem
    })).every((flag: boolean) => flag)) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ValidatedChartTimeSeries> & MinItems<1>)",
        value: input.data
    }), undefined === input.has_dynamic_y_axis || "boolean" === typeof input.has_dynamic_y_axis || _report(_exceptionable, {
        path: _path + ".has_dynamic_y_axis",
        expected: "(boolean | undefined)",
        value: input.has_dynamic_y_axis
    }), "line" === input.chart_type || _report(_exceptionable, {
        path: _path + ".chart_type",
        expected: "\"line\"",
        value: input.chart_type
    })].every((flag: boolean) => flag); const _vo5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.name || _report(_exceptionable, {
        path: _path + ".name",
        expected: "string",
        value: input.name
    }), undefined === input.label || "string" === typeof input.label || _report(_exceptionable, {
        path: _path + ".label",
        expected: "(string | undefined)",
        value: input.label
    }), (Array.isArray(input.values) || _report(_exceptionable, {
        path: _path + ".values",
        expected: "(Array<ChartTimeSeriesPoint> & MinItems<1>)",
        value: input.values
    })) && ((1 <= input.values.length || _report(_exceptionable, {
        path: _path + ".values",
        expected: "Array<> & MinItems<1>",
        value: input.values
    })) && input.values.map((elem: any, _index13: number) => ("object" === typeof elem && null !== elem || _report(_exceptionable, {
        path: _path + ".values[" + _index13 + "]",
        expected: "ChartTimeSeriesPoint",
        value: elem
    })) && _vo6(elem, _path + ".values[" + _index13 + "]", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".values[" + _index13 + "]",
        expected: "ChartTimeSeriesPoint",
        value: elem
    })).every((flag: boolean) => flag)) || _report(_exceptionable, {
        path: _path + ".values",
        expected: "(Array<ChartTimeSeriesPoint> & MinItems<1>)",
        value: input.values
    })].every((flag: boolean) => flag); const _vo6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.time || _report(_exceptionable, {
        path: _path + ".time",
        expected: "string",
        value: input.time
    }), "number" === typeof input.value || _report(_exceptionable, {
        path: _path + ".value",
        expected: "number",
        value: input.value
    })].every((flag: boolean) => flag); const _vo7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [undefined === input.title || "string" === typeof input.title || _report(_exceptionable, {
        path: _path + ".title",
        expected: "(string | undefined)",
        value: input.title
    }), (Array.isArray(input.data) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ValidatedChartTimeSeries> & MinItems<1>)",
        value: input.data
    })) && ((1 <= input.data.length || _report(_exceptionable, {
        path: _path + ".data",
        expected: "Array<> & MinItems<1>",
        value: input.data
    })) && input.data.map((elem: any, _index14: number) => ("object" === typeof elem && null !== elem || _report(_exceptionable, {
        path: _path + ".data[" + _index14 + "]",
        expected: "ValidatedChartTimeSeries",
        value: elem
    })) && _vo5(elem, _path + ".data[" + _index14 + "]", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".data[" + _index14 + "]",
        expected: "ValidatedChartTimeSeries",
        value: elem
    })).every((flag: boolean) => flag)) || _report(_exceptionable, {
        path: _path + ".data",
        expected: "(Array<ValidatedChartTimeSeries> & MinItems<1>)",
        value: input.data
    }), undefined === input.number_slices || "number" === typeof input.number_slices || _report(_exceptionable, {
        path: _path + ".number_slices",
        expected: "(number | undefined)",
        value: input.number_slices
    }), "stacked-bar" === input.chart_type || _report(_exceptionable, {
        path: _path + ".chart_type",
        expected: "\"stacked-bar\"",
        value: input.chart_type
    })].every((flag: boolean) => flag); const _vo8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.render_id || _report(_exceptionable, {
        path: _path + ".render_id",
        expected: "string",
        value: input.render_id
    }), 1 === input.version || _report(_exceptionable, {
        path: _path + ".version",
        expected: "1",
        value: input.version
    }), "action" === input.type || _report(_exceptionable, {
        path: _path + ".type",
        expected: "\"action\"",
        value: input.type
    }), ("object" === typeof input.payload && null !== input.payload || _report(_exceptionable, {
        path: _path + ".payload",
        expected: "ActionFencePayload",
        value: input.payload
    })) && _vo9(input.payload, _path + ".payload", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".payload",
        expected: "ActionFencePayload",
        value: input.payload
    })].every((flag: boolean) => flag); const _vo9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.action || _report(_exceptionable, {
        path: _path + ".action",
        expected: "string",
        value: input.action
    }), true].every((flag: boolean) => flag); const _vo10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.render_id || _report(_exceptionable, {
        path: _path + ".render_id",
        expected: "string",
        value: input.render_id
    }), 1 === input.version || _report(_exceptionable, {
        path: _path + ".version",
        expected: "1",
        value: input.version
    }), "view_preview" === input.type || _report(_exceptionable, {
        path: _path + ".type",
        expected: "\"view_preview\"",
        value: input.type
    }), ("object" === typeof input.payload && null !== input.payload || _report(_exceptionable, {
        path: _path + ".payload",
        expected: "ViewPreviewPayload",
        value: input.payload
    })) && _vo11(input.payload, _path + ".payload", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".payload",
        expected: "ViewPreviewPayload",
        value: input.payload
    })].every((flag: boolean) => flag); const _vo11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [("object" === typeof input.traversal && null !== input.traversal || _report(_exceptionable, {
        path: _path + ".traversal",
        expected: "ViewPreviewTraversal",
        value: input.traversal
    })) && _vo12(input.traversal, _path + ".traversal", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".traversal",
        expected: "ViewPreviewTraversal",
        value: input.traversal
    }), ("object" === typeof input.view && null !== input.view || _report(_exceptionable, {
        path: _path + ".view",
        expected: "ViewPreviewStyle",
        value: input.view
    })) && _vo14(input.view, _path + ".view", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".view",
        expected: "ViewPreviewStyle",
        value: input.view
    })].every((flag: boolean) => flag); const _vo12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [(Array.isArray(input.startSet) || _report(_exceptionable, {
        path: _path + ".startSet",
        expected: "Array<string>",
        value: input.startSet
    })) && input.startSet.map((elem: any, _index15: number) => "string" === typeof elem || _report(_exceptionable, {
        path: _path + ".startSet[" + _index15 + "]",
        expected: "string",
        value: elem
    })).every((flag: boolean) => flag) || _report(_exceptionable, {
        path: _path + ".startSet",
        expected: "Array<string>",
        value: input.startSet
    }), (Array.isArray(input.paths) || _report(_exceptionable, {
        path: _path + ".paths",
        expected: "Array<Array<DirectedTriple>>",
        value: input.paths
    })) && input.paths.map((elem: any, _index16: number) => (Array.isArray(elem) || _report(_exceptionable, {
        path: _path + ".paths[" + _index16 + "]",
        expected: "Array<DirectedTriple>",
        value: elem
    })) && elem.map((elem: any, _index17: number) => ("object" === typeof elem && null !== elem || _report(_exceptionable, {
        path: _path + ".paths[" + _index16 + "][" + _index17 + "]",
        expected: "DirectedTriple",
        value: elem
    })) && _vo13(elem, _path + ".paths[" + _index16 + "][" + _index17 + "]", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".paths[" + _index16 + "][" + _index17 + "]",
        expected: "DirectedTriple",
        value: elem
    })).every((flag: boolean) => flag) || _report(_exceptionable, {
        path: _path + ".paths[" + _index16 + "]",
        expected: "Array<DirectedTriple>",
        value: elem
    })).every((flag: boolean) => flag) || _report(_exceptionable, {
        path: _path + ".paths",
        expected: "Array<Array<DirectedTriple>>",
        value: input.paths
    }), undefined === input.startSetExpansion || "descendants" === input.startSetExpansion || _report(_exceptionable, {
        path: _path + ".startSetExpansion",
        expected: "(\"descendants\" | undefined)",
        value: input.startSetExpansion
    })].every((flag: boolean) => flag); const _vo13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["string" === typeof input.sourceType || _report(_exceptionable, {
        path: _path + ".sourceType",
        expected: "string",
        value: input.sourceType
    }), "string" === typeof input.targetType || _report(_exceptionable, {
        path: _path + ".targetType",
        expected: "string",
        value: input.targetType
    }), "string" === typeof input.referenceType || _report(_exceptionable, {
        path: _path + ".referenceType",
        expected: "string",
        value: input.referenceType
    }), "outgoing" === input.direction || "incoming" === input.direction || _report(_exceptionable, {
        path: _path + ".direction",
        expected: "(\"incoming\" | \"outgoing\")",
        value: input.direction
    })].every((flag: boolean) => flag); const _vo14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ["bubble" === input.viewName || "timeline" === input.viewName || "dependencyMap" === input.viewName || "relationships3" === input.viewName || "modernizedBlockDiagram" === input.viewName || _report(_exceptionable, {
        path: _path + ".viewName",
        expected: "(\"bubble\" | \"dependencyMap\" | \"modernizedBlockDiagram\" | \"relationships3\" | \"timeline\")",
        value: input.viewName
    }), (null !== input.milestoneFields || _report(_exceptionable, {
        path: _path + ".milestoneFields",
        expected: "(\"all\" | Array<string> | undefined)",
        value: input.milestoneFields
    })) && (undefined === input.milestoneFields || "all" === input.milestoneFields || (Array.isArray(input.milestoneFields) || _report(_exceptionable, {
        path: _path + ".milestoneFields",
        expected: "(\"all\" | Array<string> | undefined)",
        value: input.milestoneFields
    })) && input.milestoneFields.map((elem: any, _index18: number) => "string" === typeof elem || _report(_exceptionable, {
        path: _path + ".milestoneFields[" + _index18 + "]",
        expected: "string",
        value: elem
    })).every((flag: boolean) => flag) || _report(_exceptionable, {
        path: _path + ".milestoneFields",
        expected: "(\"all\" | Array<string> | undefined)",
        value: input.milestoneFields
    })), undefined === input.bubbleFields || ("object" === typeof input.bubbleFields && null !== input.bubbleFields && false === Array.isArray(input.bubbleFields) || _report(_exceptionable, {
        path: _path + ".bubbleFields",
        expected: "(__type | undefined)",
        value: input.bubbleFields
    })) && _vo15(input.bubbleFields, _path + ".bubbleFields", true && _exceptionable) || _report(_exceptionable, {
        path: _path + ".bubbleFields",
        expected: "(__type | undefined)",
        value: input.bubbleFields
    })].every((flag: boolean) => flag); const _vo15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => [undefined === input.x || "string" === typeof input.x || _report(_exceptionable, {
        path: _path + ".x",
        expected: "(string | undefined)",
        value: input.x
    }), undefined === input.y || "string" === typeof input.y || _report(_exceptionable, {
        path: _path + ".y",
        expected: "(string | undefined)",
        value: input.y
    }), undefined === input.size || "string" === typeof input.size || _report(_exceptionable, {
        path: _path + ".size",
        expected: "(string | undefined)",
        value: input.size
    })].every((flag: boolean) => flag); const _vu0 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
    if ("pie" === input.chart_type)
        return _vo3(input, _path, true && _exceptionable);
    else if ("bar" === input.chart_type)
        return _vo1(input, _path, true && _exceptionable);
    else if ("line" === input.chart_type)
        return _vo4(input, _path, true && _exceptionable);
    else if ("stacked-bar" === input.chart_type)
        return _vo7(input, _path, true && _exceptionable);
    else
        return _report(_exceptionable, {
            path: _path,
            expected: "(PieChartInput | BarChartInput | LineChartInput | StackedBarChartInput)",
            value: input
        });
})(); const _vu1 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
    if ("view_preview" === input.type)
        return _vo10(input, _path, true && _exceptionable);
    else if ("action" === input.type)
        return _vo8(input, _path, true && _exceptionable);
    else if ("chart" === input.type)
        return _vo0(input, _path, true && _exceptionable);
    else
        return _report(_exceptionable, {
            path: _path,
            expected: "(ViewPreviewRender | ActionRender | ChartRender)",
            value: input
        });
})(); const __is = (input: any): input is RenderMetadata => "object" === typeof input && null !== input && _iu1(input); let errors: any; let _report: any; return __typia_transform__createStandardSchema._createStandardSchema((input: any): import("typia").IValidation<RenderMetadata> => {
    if (false === __is(input)) {
        errors = [];
        _report = (__typia_transform__validateReport._validateReport as any)(errors);
        ((input: any, _path: string, _exceptionable: boolean = true) => ("object" === typeof input && null !== input || _report(true, {
            path: _path + "",
            expected: "(ActionRender | ChartRender | ViewPreviewRender)",
            value: input
        })) && _vu1(input, _path + "", true) || _report(true, {
            path: _path + "",
            expected: "(ActionRender | ChartRender | ViewPreviewRender)",
            value: input
        }))(input, "$input", true);
        const success = 0 === errors.length;
        return success ? {
            success,
            data: input
        } : {
            success,
            errors,
            data: input
        } as any;
    }
    return {
        success: true,
        data: input
    } as any;
}); })();
export const collectRenders = (entries: unknown[]): RenderStore => {
    const renders: RenderStore = {};
    for (const entry of entries) {
        const result = validateRenderMetadata(entry);
        if (!result.success) {
            logWarn(new Error('Invalid assistant render metadata'));
            continue;
        }
        renders[result.data.render_id] = result.data;
    }
    return renders;
};
// Matches e.g. ```render:chart:a1b2c3d4``` or ```render:view_preview:a1b2c3d4```, with or without a newline.
const RENDER_PLACEHOLDER_REGEX = /```render:(chart|action|view_preview):([0-9a-f]{8})\n?```/g;
const FENCE = '```';
const wrapWithFence = (language: string, payload: unknown): string => `\n${FENCE}${language}\n${JSON.stringify(payload)}\n${FENCE}\n`;
export const getMissingChartRenderIds = (content: string, renders: RenderStore): string[] => [...content.matchAll(RENDER_PLACEHOLDER_REGEX)]
    .filter(([, type, renderId]) => type === 'chart' && renders[renderId]?.type !== 'chart')
    .map(([, , renderId]) => renderId);
export const replaceRenderPlaceholders = (content: string, renders: RenderStore): string => content.replace(RENDER_PLACEHOLDER_REGEX, (_placeholder, type: string, renderId: string): string => {
    const render = renders[renderId];
    if (!render || render.type !== type)
        return '';
    switch (render.type) {
        case 'chart': {
            const { chart_type, ...payload } = render.payload;
            return wrapWithFence(CHART_FENCES[chart_type], payload);
        }
        case 'action':
            return wrapWithFence(ACTION_FENCE, render.payload);
        case 'view_preview':
            return wrapWithFence(VIEW_PREVIEW_FENCE, render.payload);
    }
});
